'use strict';

(() => {
  document.documentElement.classList.add('mn-js');
  const root = window.Shopify?.routes?.root || '/';
  let searchTrigger;
  let searchTimer;
  let searchRequest;

  function closeMenu() {
    const menu = document.querySelector('.minutolo-ui .menu-toggle');
    const nav = document.getElementById('mn-main-nav');
    menu?.setAttribute('aria-expanded', 'false');
    menu?.setAttribute('aria-label', 'Menü öffnen');
    nav?.classList.remove('is-open');
  }

  document.addEventListener('click', (event) => {
    const menu = event.target.closest('.minutolo-ui .menu-toggle');
    if (menu) {
      const nav = document.getElementById('mn-main-nav');
      const open = menu.getAttribute('aria-expanded') !== 'true';
      menu.setAttribute('aria-expanded', String(open));
      menu.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
      nav?.classList.toggle('is-open', open);
      return;
    }
    if (event.target.closest('#mn-main-nav a')) closeMenu();

    const filter = event.target.closest('[data-mn-filter]');
    if (filter) {
      const section = filter.closest('.products-section');
      const category = filter.dataset.mnFilter;
      section.querySelectorAll('[data-mn-filter]').forEach(button => {
        button.setAttribute('aria-pressed', String(button === filter));
      });
      section.querySelectorAll('[data-mn-panel]').forEach(panel => {
        panel.hidden = panel.dataset.mnPanel !== category;
      });
      const more = section.querySelector('[data-mn-more]');
      if (more) {
        const collections = {'Auswahl': 'all', 'Brände & Spirituosen': 'brande-spirituosen', 'Liköre': 'likore', 'Essig': 'essig', 'Öle': 'ole'};
        more.href = root + 'collections/' + (collections[category] || 'all');
        more.textContent = category === 'Auswahl' ? 'Das ganze Sortiment →' : 'Alle ' + category + ' →';
      }
      return;
    }

    const trigger = event.target.closest('[data-mn-search]');
    const dialog = document.getElementById('mn-search-dialog');
    if (trigger && dialog?.showModal) {
      event.preventDefault();
      searchTrigger = trigger;
      dialog.showModal();
      document.getElementById('mn-search-input')?.focus();
      return;
    }
    if (event.target.closest('[data-mn-close]')) dialog?.close();
    if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  });

  // A normal GET search form remains available if suggestions fail or JavaScript is disabled.
  document.addEventListener('input', (event) => {
    if (event.target.id !== 'mn-search-input') return;
    clearTimeout(searchTimer);
    searchRequest?.abort();
    const query = event.target.value.trim();
    const status = document.getElementById('mn-search-status');
    const results = document.getElementById('mn-search-results');
    results.replaceChildren();
    status.textContent = '';
    if (query.length < 2) return;
    searchTimer = setTimeout(async () => {
      const controller = new AbortController();
      searchRequest = controller;
      status.textContent = 'Produkte werden gesucht …';
      try {
        const params = new URLSearchParams({q: query, 'resources[type]': 'product', 'resources[limit]': '8'});
        const response = await fetch(root + 'search/suggest.json?' + params, {signal: controller.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (controller.signal.aborted) return;
        const products = data.resources?.results?.products || [];
        status.textContent = products.length ? 'Passende Produkte' : 'Keine Vorschläge. Mit „Suchen“ das ganze Sortiment durchsuchen.';
        for (const product of products) {
          const link = document.createElement('a');
          link.className = 'result';
          const url = new URL(product.url, location.origin);
          if (url.origin !== location.origin) continue;
          link.href = url.pathname + url.search;
          const imageUrl = product.featured_image?.url || product.image;
          if (typeof imageUrl === 'string' && imageUrl) {
            const image = document.createElement('img');
            image.src = imageUrl;
            image.alt = '';
            image.width = 76;
            image.height = 85;
            link.append(image);
          }
          const text = document.createElement('div');
          const name = document.createElement('strong');
          name.textContent = product.title;
          text.append(name);
          const type = document.createElement('span');
          type.textContent = product.type || '';
          text.append(type);
          link.append(text);
          results.append(link);
        }
      } catch (error) {
        if (error.name !== 'AbortError') status.textContent = 'Mit „Suchen“ das ganze Sortiment durchsuchen.';
      }
    }, 200);
  });

  document.addEventListener('close', (event) => {
    if (event.target.id === 'mn-search-dialog') {
      clearTimeout(searchTimer);
      searchRequest?.abort();
      searchTrigger?.focus();
    }
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu();
  });
  document.addEventListener('shopify:section:unload', () => {
    clearTimeout(searchTimer);
    searchRequest?.abort();
  });
  async function syncCartCount() {
    try {
      const response = await fetch(root + 'cart.js');
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-mn-cart-count]').forEach(badge => {
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
      });
    } catch { /* The native cart remains the source of truth. */ }
  }
  document.addEventListener('cart:update', syncCartCount);
  import('@shopify/events').then(({StandardEvents}) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, event => {
      Promise.resolve(event.promise).then(syncCartCount).catch(() => {});
    });
  }).catch(() => {});
  window.addEventListener('pageshow', event => {
    if (event.persisted) syncCartCount();
  });
})();
